import React, { useEffect, useState } from "react";
import { IGroupData } from "../models/Group";
import { getGroupsByRole } from "../services/api/group.service";
import { GROUP_IMAGES } from "../util/constants/GROUP_IMAGES";

import ArrowExit from "../assets/images/arrow-modal-exit.png";

interface ModalProps {
  onHandleAccept: (group: IGroupData) => void;
  onClose: VoidFunction;
  current: IGroupData | null;
}

export const ModalGroups = ({
  onHandleAccept,
  onClose,
  current,
}: ModalProps) => {
  const [groupList, setGroupList] = useState<IGroupData[]>([]);

  const [screenSize, setScreenSize] = useState<{
    width: number;
    height: number;
  }>({ width: window.innerWidth, height: window.innerHeight });
  const [modalSize, setModalSize] = useState<string>("1");

  const getGroups = () => {
    getGroupsByRole().then((result) => {
      if (result) {
        const groups = result.response.data;
        setGroupList(groups);
      }
    });
  };

  const getGroupImage = (name: string) => {
    const groupData = GROUP_IMAGES.find((group) => group.name === name);
    return groupData?.image;
  };

  const getCalcScale = () => {
    const width = screenSize.width;
    const height = screenSize.height;

    const defaultSize = '1'

    const fractionWidth = width / 650;
    const fractionHeight = (height - 100) / 300;

    const isWidthLonger = 650 * fractionHeight >= width - 100;

    if (width <= 600 && width < height) {
      setModalSize(defaultSize);
      return;
    }

    if (isWidthLonger) {
      setModalSize(fractionWidth.toString());
      return;
    }

    if (fractionHeight < 1) {
      const waitSize = 300 * 0.9;
      const currentSize = height - 60;
      const isLonger = waitSize >= currentSize;
      if (isLonger) {
        const difference = waitSize - currentSize;
        const heightDifference = waitSize - difference;
        const fractionFixed = (0.9 * heightDifference) / waitSize;

        setModalSize(fractionFixed.toString());
        return;
      }
    } else {
      const calculatedSize = ((height - 100) * 0.9) / 300;
      setModalSize(calculatedSize.toString());
      return;
    }
  };

  const isPortraitAndMiniumSize = () => {
    return screenSize.width <= 600 && screenSize.width < screenSize.height;
  }

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    getCalcScale();
  }, [screenSize]);

  useEffect(() => {
    getCalcScale();
    getGroups();
  }, []);

  return (
    <div className="modal modal-groups">
      <div className={`modal-body modal-group-body ${isPortraitAndMiniumSize() ? 'ordered' : ''}`} style={{ scale: modalSize }}>
        {
          !!current && (
            <button key="arrow-exit" className="exit-button" onClick={onClose}>
              <img key="arrow-exit-image" src={ArrowExit} alt="arrow-exit" />
            </button>
          )
        }
        <div className="gap-4 grid-items">
          {groupList.map((group) => (
            <div
              key={group.id}
              onClick={() => onHandleAccept(group)}
              className="flex flex-column gap-4 group-button"
            >
              <img src={getGroupImage(group.name)} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
